// ============================================================
// 终端小部件：jkl@jkdy:~$ 命令引擎（右下 Dock）
// ============================================================

import { showToast, glitchScreen, tankScreen } from "./ui";

const HELP = [
  { cmd: "help", desc: "显示可用指令" },
  { cmd: "whoami", desc: "看看这位导演是谁" },
  { cmd: "date", desc: "显示当前时间" },
  { cmd: "projects", desc: "列出代表作品" },
  { cmd: "matrix on / off", desc: "开关矩阵雨" },
  { cmd: "glitch", desc: "触发一次全局故障" },
  { cmd: "konami", desc: "隐藏指令：矩阵超频" },
  { cmd: "jkl", desc: "对暗号" },
  { cmd: "panzer", desc: "隐藏指令：召唤坦克" },
  { cmd: "clear", desc: "清屏" },
  { cmd: "exit", desc: "关闭终端" },
];

const COFFEE = [
  "        ( (",
  "         ) )",
  "      .........",
  "      |       |___",
  "      |       |   ]",
  "      `-------'---'",
  "sudo: 权限被拒绝 —— 咖啡机不在服务区。导演请先下单。",
];

export default function initTerminal(matrixApi) {
  const dock = document.getElementById("tk-dock");
  const toggle = document.getElementById("tk-toggle");
  const panel = document.getElementById("tk-panel");
  const closeBtn = document.getElementById("tk-close");
  const log = document.getElementById("tk-log");
  const input = document.getElementById("tk-input");
  if (!dock || !toggle || !panel || !log || !input) return;

  const print = (text, cls = "") => {
    const p = document.createElement("p");
    if (cls) p.className = cls;
    p.textContent = text;
    log.appendChild(p);
    log.scrollTop = log.scrollHeight;
  };

  const echo = (cmd) => {
    const p = document.createElement("p");
    p.innerHTML = `<span style="color:#00ff9c">jkl@jkdy:~$</span> ${escapeHtml(cmd)}`;
    log.appendChild(p);
    log.scrollTop = log.scrollHeight;
  };

  const escapeHtml = (s) =>
    s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");

  const open = () => {
    panel.classList.add("is-open");
    panel.setAttribute("aria-hidden", "false");
    toggle.setAttribute("aria-expanded", "true");
    toggle.style.display = "none";
    setTimeout(() => input.focus(), 120);
  };

  const close = () => {
    panel.classList.remove("is-open");
    panel.setAttribute("aria-hidden", "true");
    toggle.setAttribute("aria-expanded", "false");
    toggle.style.display = "";
  };

  toggle.addEventListener("click", open);
  closeBtn.addEventListener("click", close);

  const dispatch = (raw) => {
    const cmd = raw.trim().toLowerCase();
    echo(raw.trim() || " ");

    if (cmd === "help" || cmd === "?") {
      print("可用指令：", "c-info");
      HELP.forEach((h) => print(`  ${h.cmd.padEnd(14)} — ${h.desc}`, "c-dim"));
    } else if (cmd === "whoami") {
      print("极客导演 —— 独立 AI 创作者 / 自媒体人", "c-ok");
      print("专注 AI 视频 · AI 图像 · AI 音乐，让想象即刻成片。", "c-ok");
    } else if (cmd === "date") {
      print(new Date().toLocaleString("zh-CN", { hour12: false }), "c-info");
    } else if (cmd === "projects") {
      print("render_video.sh  — AI 视频成片", "c-ok");
      print("generate_image.py — AI 图像生成", "c-ok");
      print("compose_music.py — AI 音乐作曲", "c-ok");
    } else if (cmd === "matrix on") {
      matrixApi?.setMode("normal");
      print("矩阵雨已启动。欢迎来到矩阵，导演。", "c-ok");
    } else if (cmd === "matrix off") {
      matrixApi?.setMode("off");
      print("矩阵雨已关闭。现实世界有点无聊。", "c-dim");
    } else if (cmd === "glitch") {
      glitchScreen(2200);
      print("GLITCH MODE: ON (2.2s)", "c-err");
      showToast("⚠ 系统故障已注入 —— 一切正常（大概）", 2400);
    } else if (cmd === "konami") {
      matrixApi?.setMode("overdrive");
      glitchScreen(1400);
      print("MATRIX OVERDRIVE ✓ 矩阵已超频 8 秒", "c-err");
      showToast("🕹 KONAMI 指令已执行：矩阵超频模式", 3000);
    } else if (cmd === "jkl") {
      print("暗号正确。你很有品味，导演。", "c-ok");
      showToast("🕶 JKDY 暗号已识别", 2400);
    } else if (cmd === "panzer") {
      // GTA 坦克秘籍：终端触发坦克彩蛋（与键盘序列 panzer 同特效）
      tankScreen();
      print("RHINO 坦克已部署 —— 感觉被发现了吗？", "c-ok");
      showToast("🪖 PANZER 指令已执行：坦克已部署", 3200);
    } else if (cmd === "sudo make-me-coffee") {
      COFFEE.forEach((l) => print(l, l.includes("sudo") ? "c-err" : "c-dim"));
    } else if (cmd === "sudo rm -rf /") {
      print("nice try, hacker. 系统表示拒绝执行。", "c-err");
      showToast("🚫 检测到危险指令，已被拦截", 2600);
    } else if (cmd === "clear" || cmd === "cls") {
      log.innerHTML = "";
    } else if (cmd === "exit") {
      print("断开连接。下次开机，依旧是导演。", "c-dim");
      setTimeout(close, 450);
    } else if (!cmd) {
      // 空命令，无输出
    } else {
      print(`zsh: command not found: ${raw.trim()} — 输入 help 查看可用指令`, "c-err");
    }
  };

  input.addEventListener("keydown", (e) => {
    if (e.key === "Enter") {
      dispatch(input.value);
      input.value = "";
    } else if (e.key === "Escape") {
      close();
    }
    e.stopPropagation();
  });

  // 初始欢迎语
  print("JKDY://TERMINAL v2.6.6 — 连接成功", "c-dim");
  print("输入 help 查看可用指令，试试 konami 或 jkl。", "c-dim");
}
